import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CxFormsModule } from '@forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationModule } from '@notification';
import { UiFormatModule } from '@ui-format';
import { UiMessagesModule } from '@ui-messages';
import { LoginScreen } from './login.screen.component';
import { DxPopupModule } from 'devextreme-angular/ui/popup';
import { DxButtonModule } from 'devextreme-angular/ui/button';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        CxFormsModule,
        NotificationModule,
        RouterModule,
        UiFormatModule,
        UiMessagesModule,
        DxPopupModule,
        DxButtonModule
    ],
    declarations: [
        LoginScreen
    ],
    exports: [
        LoginScreen
    ],
    providers : [
   
    ]
})
export class LoginModule {}

export { LoginScreen }